import type { AppointmentsFeatureConfig } from './type';

export const appointments: Partial<AppointmentsFeatureConfig> = {
    showHomeBranch: false,
};
